var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDuplicate = function SvgDuplicate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2304_12135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 4.5V9.83333C4.66602 10.3638 4.87673 10.8725 5.2518 11.2475C5.62687 11.6226 6.13558 11.8333 6.66602 11.8333H11.9993C12.5298 11.8333 13.0385 11.6226 13.4136 11.2475C13.7886 10.8725 13.9993 10.3638 13.9993 9.83333V4.5C13.9993 3.96957 13.7886 3.46086 13.4136 3.08579C13.0385 2.71071 12.5298 2.5 11.9993 2.5H6.66602C6.13558 2.5 5.62687 2.71071 5.2518 3.08579C4.87673 3.46086 4.66602 3.96957 4.66602 4.5Z",
    stroke: "#004F7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.8333V12.5C11.3333 13.0304 11.1226 13.5391 10.7475 13.9142C10.3725 14.2893 9.86377 14.5 9.33333 14.5H4C3.46957 14.5 2.96086 14.2893 2.58579 13.9142C2.21071 13.5391 2 13.0304 2 12.5V7.16666C2 6.63623 2.21071 6.12752 2.58579 5.75245C2.96086 5.37738 3.46957 5.16666 4 5.16666H4.66667",
    stroke: "#004F7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 8.5V5.83334",
    stroke: "#004F7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.16613H10.6667",
    stroke: "#004F7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2304_12135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "78ca70645894728f0daa89aae5fc1f64.svg";